import { FC } from "react";

const ErrorMessage: FC<{error?: string}> = ({error}) => error && (
    <div className="rounded-[18px] border border-red-200 bg-red-50 px-4 py-3 text-red-700" role="alert">
        <span className="block sm:inline">{error}</span>
    </div>
)

export default ErrorMessage;
